import React from "react";
import { ComponentProjectDetailPageInitialState, PageNewState } from ".";

export const ComponentProjectDetailPageContext = React.createContext({
  pageState: ComponentProjectDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
